import React from 'react'
import { useTranslation } from 'react-i18next'
import { KibTopLevelAlert } from '@chewy/kib-messaging-react'

import '@chewy/kib-messaging-styles/dist/styles/kib-alert-icon.css'
import '@chewy/kib-messaging-styles/dist/styles/kib-top-level-alert.css'

export interface TaskFormValidationErrorToastProps {
  onClose?: () => void
}

export const TaskFormValidationErrorToast: React.FC<
  TaskFormValidationErrorToastProps
> = ({ onClose }) => {
  const { t } = useTranslation(['Tasks'])

  return (
    <KibTopLevelAlert
      dismissible
      heading={t('Tasks:TASK_FORM_VALIDATION_ERROR_MESSAGE')}
      severity="error"
      onDismiss={onClose}
    />
  )
}
